import TagManager from 'react-gtm-module'

export function sendButtonClickGTM(text?: string, url?: string): void {
  TagManager.dataLayer({
    dataLayer: {
      event: 'button_click',
      button_url: url,
      button_text: text,
    },
  })
}
